import { useSelector } from 'react-redux'
import { useCurrentPractice } from 'contexts/PracticeContext'
import { selectContext } from 'selectors/auth'
import { isManagerOrAdmin } from 'util/unified'

export interface CapitalActivePayoutsAccess {
	capitalPayoutReportingEnabled: boolean
	hasAllowedRole: boolean
	canAccess: boolean
}

export const useCapitalActivePayoutsAccess = (): CapitalActivePayoutsAccess => {
	const { currentPracticeObject } = useCurrentPractice()
	const context = useSelector(selectContext)

	const capitalPayoutReportingEnabled =
		currentPracticeObject?.consolidatedPractice?.settings?.capitalPayoutReportingEnabled === true
	const hasAllowedRole = isManagerOrAdmin(context, currentPracticeObject)

	return {
		capitalPayoutReportingEnabled,
		hasAllowedRole,
		canAccess: capitalPayoutReportingEnabled && hasAllowedRole
	}
}
